
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import {
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import AskGoOn from "@/views/ai-builder-v3/components/delete-dialog.vue";

@Component({ components: { AskGoOn, InputNumberV3 } })
export default class QuestionCardV3 extends Vue {
  // 选题模式：select，配分模式：score
  @Prop({ type: String, default: "select" })
  mode!: "select" | "score" | "view";
  @Prop({ type: QuestionV2, default: new QuestionV2() })
  question!: QuestionV2;
  @Prop({ type: Boolean, default: false })
  active!: boolean;

  @Prop({ type: Number, default: 0 })
  defaultScore!: number;

  // 题目序号
  @Prop({ type: Number, default: 0 })
  totalCount!: number;
  @Prop({ type: Number, default: 0 })
  index!: number;

  // 操作
  @Prop({ type: Boolean, default: false })
  canView!: boolean;
  @Prop({ type: Boolean, default: false })
  canEdit!: boolean;
  @Prop({ type: Boolean, default: false })
  canDel!: boolean;

  get dimension() {
    return this.question.firstFilterDimension;
  }

  score = this.defaultScore;
  delQuestionDialog = false;

  async delQuestion() {
    try {
      await QuestionV2Object.delete(this.question.questionId);
      this.$message.success("删除成功");
      this.delQuestionDialog = false;
      this.delSuccess();
    } catch (e) {
      this.$message.error("删除失败，请重试");
    }
  }

  @Emit()
  view() {
    if (!this.canView) return;

    return this.question;
  }

  @Emit()
  select() {
    return this.question;
  }

  @Emit()
  cancelSelection() {
    return this.question;
  }

  @Emit()
  editQuestion() {
    return this.question;
  }

  @Emit()
  delSuccess() {
    return this.question;
  }

  changeScore() {
    this.$emit("changeScore", { question: this.question, score: this.score });
    return { question: this.question, score: this.score };
  }
}
